// Check if table of contents exists
if(document.querySelector('#tableOfContents')) {
    // Get all table of contents slides
    var slides = document.querySelectorAll('#tableOfContents a');
    // Add click event listener to each slide
    for(var i = 0; i < slides.length; i++) {
        slides[i].addEventListener('click', function (e) {
            // Update video time with start time of selected video section
            document.querySelector('#aprimoVideo').currentTime = e.target.parentNode.getAttribute('data-start');
            // Play the video
            document.querySelector('#aprimoVideo').play();
        });
    }

    // Periodically check if video has been loaded into viewport
    var isVideoPlaying = setInterval(function() {
        // When video is loaded
        if (document.querySelector('#aprimoVideo')) {
            // Call function to update table of contents
            updateTableOfContents();
            // Clear check for video
            clearInterval(isVideoPlaying);
        }
    }, 2000);
}



function updateTableOfContents() {
    // Create variables and array to store timestamps
    var timestamps = [],
        now = 0,
        old = 0;
    // Loop through each slide to add start, end and ID to timestamp array
    var slides = document.querySelectorAll('#tableOfContents a');
    for (var i = 0; i < slides.length; ++i) {
        if (slides[i].getAttribute('data-start')) {
            timestamps.push({
                start: slides[i].getAttribute('data-start'),
                end: slides[i].getAttribute('data-end'),
                elm: slides[i].getAttribute('id')
            });
        }
    }
    // Check for video time updating
    document.querySelector('#aprimoVideo').addEventListener('timeupdate', function () {
        // Assign current video time to variable
        now = parseInt(this.currentTime);
        // Throttle timeupdate calls to full seconds
        if (now > old) {
            // Add active class if video section matches current timestamp otherwise remove it
            for(var i=0; i < timestamps.length; i++){
                if(timestamps[i].start <= this.currentTime && timestamps[i].end >= this.currentTime) {
                    document.querySelector('#tableOfContents a#' + timestamps[i].elm.toString()).classList.add('u-link--red');
                } else {
                    if (document.querySelector('#tableOfContents a#' + timestamps[i].elm.toString()).classList.contains('u-link--red')) {
                        document.querySelector('#tableOfContents a#' + timestamps[i].elm.toString()).classList.remove('u-link--red');
                    }
                }
            }
        }
        // Update old variable to new time value for next iteration
        old = now;
    });
}